
export default {
    methods:{
        consoleLog(msg){
            console.log(`PCALC [${this.calc}]: ${msg}`)
        },
        languageCheck(){
            let langCheck = document.getElementsByTagName("html")[0].hasAttribute("lang");
            if (langCheck) {
                let lang = document.getElementsByTagName("html")[0].getAttribute("lang");
                if (lang !== 'en') {
                    this.$i18n.locale = lang;
                }
            }
        },
        url (url) {
            let lang = (document.querySelector("meta[http-equiv='Content-Language']")) ? document.querySelector("meta[http-equiv='Content-Language']").getAttribute('content') : 'en-us';
            let newUrl = url;
            if (lang !== '' && lang !== 'en-us') {
                if (url.split("/")[1] !== lang) {
                    newUrl = '/' + lang + url;
                }
            }
            return newUrl;
        }
    }
}